import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import EOIForm, { openEoiPrint } from './EOIForm';
import EOILinkShare from './EOILinkShare';
import EOIShare from './EOIShare';

// All Expressions of Interest: who is booking, the booking names, typology,
// floor, cheque, source. New EOI starts from a client; Edit / Print per row.
const EOIList = ({ apiBase }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');
  const [form, setForm] = useState(null); // {clientId} | {eoiId}
  const [picking, setPicking] = useState(false);
  const [clients, setClients] = useState([]);
  const [cq, setCq] = useState('');
  const [brokerLink, setBrokerLink] = useState(false);
  const [shareId, setShareId] = useState(null);
  const sendPartners = async (r) => {
    if (!window.confirm(`Send ${r.eoi_number} (client ${r.contact_name}${r.broker_name ? `, broker ${r.broker_name}` : ', direct'}) to all partners for approval?`)) return;
    try {
      const x = await axios.post(`${apiBase}/eoi-review/${r.id}/send`);
      alert(x.data.results.map((y) => `${y.partner}: ${y.status === 'sent' ? 'sent' : `NOT sent — ${y.error}`}`).join('\n'));
      load();
    } catch (e) { alert(e.response?.data?.error || 'Could not send.'); }
  };
  const PREV = { awaiting: ['🤝 With partners for approval', '#d97706'], approved: ['🤝 Approved', '#16a34a'], rejected: ['🤝 Rejected', '#dc2626'] };
  const askConfirm = async (r) => {
    if (!window.confirm(`Send the WhatsApp confirmation request for ${r.eoi_number} to the primary applicant now?`)) return;
    try { const x = await axios.post(`${apiBase}/eoi-confirm/${r.id}/request`); alert(`Sent to ${x.data.to}. The badge turns green when they tap "I confirm".`); load(); }
    catch (e) { alert(e.response?.data?.error || 'Could not send the request.'); }
  };
  const CONF = { confirmed: ['✅ Confirmed on WhatsApp', '#16a34a'], awaiting: ['⏳ Awaiting WhatsApp confirmation', '#d97706'], changes_requested: ['✏️ Client asked for changes', '#dc2626'],
    needs_reconfirm: ['🔁 Edited — re-confirming', '#d97706'], send_failed: ['⚠️ Confirmation not sent', '#dc2626'] };

  const load = useCallback(() => {
    axios.get(`${apiBase}/eoi-form`).then((r) => setRows(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, [apiBase]);
  useEffect(() => { load(); }, [load]);

  const startNew = () => {
    setPicking(true); setCq('');
    axios.get(`${apiBase}/clients/list`).then((r) => setClients(r.data || [])).catch(() => {});
  };

  const term = q.trim().toLowerCase();
  const shown = term ? rows.filter((r) => [r.eoi_number, r.contact_name, r.applicant_name, r.typology, r.broker_name, r.contact_mobile]
    .some((v) => v && String(v).toLowerCase().includes(term))) : rows;
  const names = (r) => (Array.isArray(r.applicants) && r.applicants.length
    ? r.applicants.map((a) => `${a.name}${a.relation && a.relation !== 'Self' ? ` (${a.relation})` : ''}`).join(' & ')
    : r.applicant_name || '—');
  const ct = cq.trim().toLowerCase();
  const pickList = (ct ? clients.filter((c) => `${c.name} ${c.phone}`.toLowerCase().includes(ct)) : clients).slice(0, 30);

  return (
    <div>
      <div className="card">
        <div className="card-header" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
          <h2 className="card-title">📝 Expressions of Interest</h2>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <input type="search" placeholder="Search EOI no., name, broker…" value={q} onChange={(e) => setQ(e.target.value)}
              style={{ padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', width: '240px' }} />
            <button className="btn btn-secondary" onClick={() => setBrokerLink(true)}>🔗 Broker EOI link</button>
            <button className="btn btn-primary" onClick={startNew}>+ New EOI</button>
          </div>
        </div>
        <div className="table-container">
          <table className="table">
            <thead><tr><th>EOI no.</th><th>Date</th><th>Booking contact</th><th>Booking names</th><th>Typology</th><th>Floor</th><th>Amount</th><th>Source</th><th /></tr></thead>
            <tbody>
              {loading && <tr><td colSpan="9">Loading…</td></tr>}
              {!loading && shown.length === 0 && <tr><td colSpan="9" style={{ textAlign: 'center', color: '#6b7280', padding: '24px' }}>{rows.length ? 'No EOIs match.' : 'No EOIs yet — press "+ New EOI".'}</td></tr>}
              {shown.map((r) => (
                <tr key={r.id}>
                  <td style={{ fontWeight: 700, whiteSpace: 'nowrap' }}>{r.eoi_number || `#${r.id}`}{r.status === 'submitted' && <div style={{ fontSize: '11px', fontWeight: 700, color: '#fff', background: '#ea580c', borderRadius: '999px', padding: '2px 8px', display: 'inline-block', marginTop: '3px' }}>New · check</div>}
                    {PREV[r.partner_review_status] && <div style={{ fontSize: '11px', fontWeight: 700, color: PREV[r.partner_review_status][1], marginTop: '3px', whiteSpace: 'nowrap' }} title={r.partner_decision_by ? `${r.partner_decision_by} · ${new Date(r.partner_decision_at).toLocaleString('en-IN')}` : ''}>{PREV[r.partner_review_status][0]}{r.partner_decision_by ? ` · ${r.partner_decision_by}` : ''}</div>}
                    {CONF[r.confirmation_status] && <div style={{ fontSize: '11px', fontWeight: 700, color: CONF[r.confirmation_status][1], marginTop: '3px', whiteSpace: 'nowrap' }}>{CONF[r.confirmation_status][0]}</div>}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>{new Date(r.created_at).toLocaleDateString('en-IN')}</td>
                  <td>{r.client_id ? <Link to={`/clients/${r.client_id}`}>{r.contact_name || 'client'}</Link> : r.contact_name}<div style={{ fontSize: '12px', color: '#6b7280' }}>{r.contact_mobile}</div></td>
                  <td>{names(r)}</td>
                  <td>{r.typology || '—'}</td>
                  <td>{r.preferred_floor || '—'}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>{r.eoi_amount ? `₹${Number(r.eoi_amount).toLocaleString('en-IN')}` : '—'}{r.payment_id ? ' 📷' : ''}</td>
                  <td>{r.source === 'channel_partner' ? <>{r.broker_name}<div style={{ fontSize: '12px', color: '#6b7280' }}>{r.broker_firm_name}</div></> : 'Direct'}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <button className="btn btn-secondary" style={{ padding: '4px 8px', fontSize: '12px', marginRight: '4px' }} onClick={() => setForm({ eoiId: r.id })}>Edit</button>
                    <button className="btn btn-primary" style={{ padding: '4px 8px', fontSize: '12px', marginRight: '4px' }} onClick={() => openEoiPrint(apiBase, r.id)}>🖨️ Print</button>
                    <button className="btn btn-secondary" style={{ padding: '4px 8px', fontSize: '12px', background: '#f0fdf4', color: '#15803d', borderColor: '#86efac', marginRight: '4px' }} onClick={() => setShareId(r.id)}>📤 Share</button>
                    {!['approved', 'rejected'].includes(r.partner_review_status) && <button className="btn btn-secondary" style={{ padding: '4px 8px', fontSize: '12px', marginRight: '4px' }} onClick={() => sendPartners(r)}>🤝 Send to partners</button>}
                    {r.confirmation_status !== 'confirmed' && <button className="btn btn-secondary" style={{ padding: '4px 8px', fontSize: '12px' }} onClick={() => askConfirm(r)}>📲 Ask to confirm</button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {picking && (
        <div onClick={() => setPicking(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(17,24,39,.55)', zIndex: 1000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '40px 12px' }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: '16px', width: '100%', maxWidth: '480px', padding: '20px' }}>
            <h3 style={{ margin: '0 0 4px', fontSize: '19px' }}>Who is booking?</h3>
            <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '10px' }}>Pick the client. New client? Add them on the Clients page or Walk-ins first.</div>
            <input autoFocus placeholder="Search name or mobile" value={cq} onChange={(e) => setCq(e.target.value)}
              style={{ width: '100%', padding: '12px 14px', border: '1.5px solid #d1d5db', borderRadius: '10px', fontSize: '16px', boxSizing: 'border-box' }} />
            <div style={{ maxHeight: '320px', overflowY: 'auto', marginTop: '8px' }}>
              {pickList.map((c) => (
                <div key={c.id} onClick={() => { setPicking(false); setForm({ clientId: c.id }); }}
                  style={{ padding: '12px', borderBottom: '1px solid #f3f4f6', cursor: 'pointer', fontSize: '15px' }}>
                  <b>{c.name}</b> <span style={{ color: '#6b7280' }}>{c.phone}</span>
                </div>
              ))}
              {!pickList.length && <div style={{ padding: '12px', color: '#9ca3af' }}>No match.</div>}
            </div>
          </div>
        </div>
      )}

      {shareId && <EOIShare apiBase={apiBase} eoiId={shareId} onClose={() => setShareId(null)} />}
      {brokerLink && <EOILinkShare apiBase={apiBase} kind="broker" onClose={() => setBrokerLink(false)} />}
      {form && <EOIForm apiBase={apiBase} clientId={form.clientId} eoiId={form.eoiId} onClose={(changed) => { setForm(null); if (changed) load(); }} />}
    </div>
  );
};

export default EOIList;
